import React from "react";
import ReactDOM from "react-dom";

import "typeface-source-sans-pro";
import "bootstrap/dist/css/bootstrap.min.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@progress/kendo-theme-default/dist/all.css';
import '@progress/kendo-theme-bootstrap/dist/all.css';
import "@progress/kendo-font-icons/dist/index.css";
import "kekule/dist/themes/default/kekule.css";
import 'hammerjs';

import PropTypes from "prop-types";
import { Provider } from "react-redux";
import rootReducer from "./../src/custom_modules/methodsetup/reducers/index";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from 'redux-thunk';
import { setDefaultTranslations, setDefaultLanguage } from "react-multi-lang";
// import pt from "./pt.json";
import en from "././custom_modules/translations/en/en.json";
import ko from "././custom_modules/translations/ko/ko.json";
import fr from "././custom_modules/translations/fr/fr.json";
import de from "././custom_modules/translations/de/de.json";
import "./js/lib/jquerysession.js";
import { IntlProvider } from 'react-intl';
// import messages from './messages';

import App from "./App";

import { GoogleOAuthProvider } from '@react-oauth/google';
// const {onlyOfficeReadOnly} = lazy(() => import('./custom_modules/DownloadReport.jsx'));
import { registerLicense } from '@syncfusion/ej2-base';

setDefaultTranslations({en,ko,fr,de });

if (localStorage.getItem("ElnLang") !== undefined && localStorage.getItem("ElnLang") !== null) {
  setDefaultLanguage(localStorage.getItem("ElnLang"));
} else {
  setDefaultLanguage("en");
  localStorage.setItem("ElnLang", "en");
}


// const customAlertTemplate = ({ style, options, message, close }) => (
//   <div style={style}>
//     {options.type === 'info' && '!'}
//     {options.type === 'success' && ':)'}
//     {options.type === 'error' && ':('}
//     {message}
//     <button onClick={close}>X</button>
//   </div>
// )


const Routing = ({ store }) => (
  <Provider store={store}>
    <IntlProvider locale="en">
      <App />
    </IntlProvider>
  </Provider>
);

Routing.propTypes = {
  store: PropTypes.object.isRequired
};


// Add this in node_modules/react-dom/index.js
window.React1 = require("react");

// Add this in your component file
require("react-dom");
window.React2 = require("react");

const initialState = {};

const middleware = [thunk];

const store = createStore(rootReducer, initialState,
  compose(
    applyMiddleware(...middleware),
    // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()

  ));

// var requireAuth = (store, nextState, replace) => {
//   console.log("store: ", store);
// };
// for demo lic
// Ngo9BigBOggjHTQxAR8/V1NCaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXdcd3RdR2dcUUB1XkE=
// for test server
// Ngo9BigBOggjHTQxAR8/V1NCaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXhccnRXQmFdUkd/WEs=

//License key updated for Version 28.2.x
registerLicense('Ngo9BigBOggjHTQxAR8/V1NMaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWX1fcXZWQ2hYWEFwWUA=');

ReactDOM.render(<GoogleOAuthProvider clientId="237917057495-m6jlb0243lod47oeend9v9bp95419gh0.apps.googleusercontent.com">
  <Provider store={store}>
    <IntlProvider locale="en">
      <App />
    </IntlProvider>
  </Provider></GoogleOAuthProvider>,
  document.getElementById("id_container")
);
